<template>
  <div class="cards-container" v-if="logos">
    <div class="cards">
      <div class="card" v-for="logo in logos">
        <!-- IMAGE -->
        <div
          class="img-container"
          :style="{ 'background-image': 'url(\'' + logo.url + '\')' }"
        ></div>

        <!-- NAME -->
        <div class="name-container">
          <span>{{ logo.organisationName }}</span>
        </div>
      </div>
    </div>

    <div class="load-more-container" v-if="showLoadMore">
      <button type="button" v-on:click="fetchLogos" :disabled="fetching">
        <span v-if="!fetching">Show More</span>
        <span v-if="fetching"><i class="fas fa-globe fa-spin"></i></span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "EarthhourLogoWall",
  data: function () {
    return {
      logos: [],
      showLoadMore: true,
      currentPage: 1,
      fetching: false,
    };
  },

  props: {
    section: {
      type: String,
      default: "school",
    },
    size: {
      type: Number,
      default: 5,
    },
  },

  async created() {
    try {
      this.logos = await this.$store.dispatch("getEarthHourLogos", {
        section: this.section,
        page: this.currentPage,
        size: this.size,
      });

      if (this.logos.length < this.size) {
        this.showLoadMore = false;
      }
    } catch (err) {
      console.error(err);
      this.logos = [];
    }
  },

  methods: {
    async fetchLogos() {
      try {
        this.fetching = true;
        const newLogos = await this.$store.dispatch("getEarthHourLogos", {
          section: this.section,
          page: ++this.currentPage,
          size: this.size,
        });

        if (newLogos && newLogos.length < this.size) {
          this.showLoadMore = false;
        }

        this.logos.push(...newLogos);
      } catch (err) {
        console.error(err);
      } finally {
        this.fetching = false;
      }
    },
  },
};
</script>

<style scoped>
.row {
  display: flex;
  justify-content: center;
  align-items: start;
}

.cards-container {
  margin: 0 1rem;
}

.cards {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 2rem;
}

.card {
  margin: 1rem;
  padding: 1rem;
  height: 170px;
  width: 170px;
  box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 23%);
  border-radius: 2px;
}

.img-container {
  display: flex;
  justify-content: center;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  width: 100%;
  height: 70%;
}

.name-container {
  margin-top: 8px;
  width: 100%;
  text-align: center;
}

.load-more-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.load-more-container button {
  height: 40px;
  padding: 0 24px;
  box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 23%);
  border-radius: 20px;
  cursor: pointer;
}

.load-more-container button span {
  font-size: 12px;
}

.load-more-container button span i {
  font-size: 18px;
}

@media only screen and (max-width: 768px) {
  .cards {
    margin-left: 5rem;
    margin-right: 5rem;
  }
}
</style>


// WEBPACK FOOTER //
// EarthhourLogoWall.vue?c73d0f80